import { Component } from '@angular/core';

@Component({
  selector: 'app-configurations',
  standalone: false,
  templateUrl: './configurations.component.html',
  styleUrl: './configurations.component.css'
})
export class ConfigurationsComponent {

}
